<template>
  <v-card  width="95%" class="m-auto">
    <v-data-table :headers="headers" :items="[remarksInfo]" hide-default-footer>
      <template v-slot:item.sno="{ item }">
            <span>{{ item.length }}1</span>
          </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "S.No", value: "sno" },
        { text: "Remarks", value: "remarks" },
        { text: "Posted by", value: "role" },
        { text: "Posted on", value: "modified_date" }
      ],
      desserts: []
    };
  },
  props: {
    remarksInfo: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
